// @flow
import { map, pipe, sortWith, ascend, prop } from 'ramda';

import type { OrderRequestSale, Params } from 'app/common/components/Cafeteria/dataTypes/orderRequestSales/OrderRequestSale.types';

import type { Request } from '../../../index';


type UrlParams = {
  orderId: number | string,
}

type ApiParams = {
  customer_id: number | string,
}

export const convertParams = ({ orderId, customerId }: Params): [ApiParams, UrlParams] => {
  return [{ customer_id: customerId }, { orderId }];
};

type ResultApi = Array<{
  id: number,
  guid: string,
  title: string,
  cost: ?number,
  portion: ?string,
  n: ?number,
  item_type: 'complex' | 'item',
  complex_list: Array<{
    id: number,
    title: string,
    portion: ?string,
    cost: ?number,
    index: number,
  }>,
}>

export const convertResult = (sales: ResultApi): Array<OrderRequestSale> => {
  return map(({ guid, title, cost, n, item_type: itemType, complex_list: complexList }) => ({
    id: guid,
    title,
    cost,
    amount: n,
    total: typeof cost === 'number' && typeof n === 'number' ? cost * n : null,
    complexItems: (
      itemType === 'complex' && complexList instanceof Array
        ? pipe(
          sortWith([
            ascend(prop('index')),
            ascend(prop('title')),
          ]),
          map(({ id, title: t, portion }) => ({
            id: String(id),
            title: t || '',
            portion: portion || '',
          })),
        )(complexList)
        : null
    ),
  }), sales);
};

export const GET_CAFETERIA_CUSTOMER_ORDERS_SALES: Request<
  Params,
  Array<OrderRequestSale>,
  UrlParams
> = [
  'cafeteria/customer/orders/{orderId}/sales',
  'get',
  ['data', 'sales', 'sales'],
];
